module.exports = __webpack_public_path__ + "img/how2.266627e6.png";